// ============================================================
// nucleo/ids.jsx — el identificador de cada cosa, generado en el teléfono.
//
// Antes se usaba Date.now(), o sea los milisegundos del reloj. Eso funciona
// en un solo teléfono y se rompe en cuanto hay dos: dos vendedores cobrando
// al mismo milisegundo producen el MISMO número, y al sincronizar una venta
// pisa a la otra. Se pierde dinero y nadie se entera.
//
// Por eso el identificador lo genera el aparato, no la base de datos:
//   - se puede vender sin internet, porque no hay que pedirle permiso a nadie
//   - al subirlo, el servidor usa ese mismo identificador como llave
//   - si la venta llega dos veces (se cortó la señal al confirmar), la
//     segunda no hace nada. Eso es lo que evita cobrar doble.
//
// Son 36 caracteres al azar. La probabilidad de que dos coincidan es tan
// baja que no vale la pena ni pensarla.
// ============================================================

import { bitacora } from "./bitacora.jsx";

let avisado = false;

// Un identificador nuevo, único, sin pedirle nada al servidor.
export function nuevoId() {
  try {
    const c = typeof globalThis !== "undefined" ? globalThis.crypto : null;
    if (c && typeof c.randomUUID === "function") return c.randomUUID();
    if (c && typeof c.getRandomValues === "function") {
      const b = c.getRandomValues(new Uint8Array(16));
      b[6] = (b[6] & 0x0f) | 0x40;              // versión 4
      b[8] = (b[8] & 0x3f) | 0x80;              // variante
      const h = [...b].map((x) => x.toString(16).padStart(2, "0")).join("");
      return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
    }
  } catch (e) { /* cae al plan de emergencia */ }

  // Plan de emergencia: un navegador viejo sin generador al azar. Sirve,
  // pero ya no es imposible que se repita, así que queda apuntado una vez.
  if (!avisado) {
    avisado = true;
    bitacora.aviso("ids", "este equipo no trae generador al azar: se usan identificadores de respaldo");
  }
  const r = () => Math.random().toString(16).slice(2).padStart(13, "0");
  const h = (r() + r() + r()).slice(0, 32);
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-4${h.slice(13, 16)}-a${h.slice(17, 20)}-${h.slice(20, 32)}`;
}

// ¿Esto tiene forma de identificador nuestro?
export const esId = (x) =>
  typeof x === "string" && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(x);

// Para las listas de pantalla (carrito, cinta de alta) basta algo corto que
// no se repita en esta sesión. No se guarda en ningún lado.
let contador = 0;
export const nuevaLlave = () => `k${++contador}`;

export const moduloIds = {
  id: "ids", nombre: "Identificadores únicos", version: "1.0", tipo: "servicio",
  requiere: [],
  probar: () => {
    const n = 5000;
    const vistos = new Set();
    for (let i = 0; i < n; i++) {
      const id = nuevoId();
      if (!esId(id)) return `el identificador ${id} no tiene la forma esperada`;
      if (vistos.has(id)) return "se repitió un identificador, que es justo lo que no puede pasar";
      vistos.add(id);
    }
    if (vistos.size !== n) return "se generaron menos identificadores de los pedidos";
    // Las llaves de pantalla también tienen que ser distintas entre sí.
    const k = new Set([nuevaLlave(), nuevaLlave(), nuevaLlave()]);
    if (k.size !== 3) return "las llaves de pantalla se repiten";
    if (esId("123456")) return "esId acepta cualquier cosa";
    if (esId(null) || esId(12345)) return "esId no rechaza lo que no es texto";
    return true;
  },
};
